import * as React from 'react'

const ARBUSD = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_103_1299)'>
      <rect width='48' height='48' rx='24' fill='white' />
      <path
        d='M27.6897 31.7681L25.2896 38.3406C25.2187 38.5229 25.2187 38.7255 25.2896 38.9077L29.4114 50.2198L34.1813 47.4652L28.4594 31.7681C28.3278 31.4035 27.8214 31.4035 27.6897 31.7681Z'
        fill='#12AAFF'
      />
      <path
        d='M32.4901 20.7092C32.3584 20.3446 31.8521 20.3446 31.7204 20.7092L29.3203 27.2818C29.2494 27.4641 29.2494 27.6666 29.3203 27.8489L36.0751 46.3716L40.845 43.617L32.4901 20.7092Z'
        fill='#12AAFF'
      />
      <path
        d='M22.4843 16H17.8764C17.5321 16 17.2182 16.2127 17.1068 16.5367L7.22261 43.6372L11.9925 46.3918L22.8793 16.5469C22.9704 16.2836 22.778 16 22.4843 16Z'
        fill='#213147'
      />
      <path
        d='M30.5557 16H25.9478C25.6035 16 25.2896 16.2127 25.1782 16.5367L13.8863 47.4855L18.6562 50.2401L30.9405 16.557C31.0418 16.2836 30.8393 16 30.5557 16Z'
        fill='#213147'
      />
    </g>
    <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' stroke='#CAD0E1' />
    <defs>
      <clipPath id='clip0_103_1299'>
        <rect width='48' height='48' rx='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

export default ARBUSD
